import { render, staticRenderFns } from "./app-snackbar.vue?vue&type=template&id=c19a7f0a&"
import script from "./app-snackbar.vue?vue&type=script&lang=js&"
export * from "./app-snackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports